export enum AsyncRules {
    // Return true if the assignment feature is active for user (don't test for specific lesson, it's for the global way to assign)
    AssignLessons = 'assignment.can-assign-lessons',
    // If true, the user can access to assignments (todo add rules to be specific (all assignments, class assignments, own assignments, etc.))
    ReadAssignments = 'assignment.read-assignment',
    IsUserHasTrainerRight = 'assignment.is-user-has-trainer-right',
}
